import ImageCard from "./ImageCard";

export default function AboutMe() {
  return (
    <>
      {/*       <h1 className="subHeading">About Me</h1> */}
      <div className="aboutMeContainer">
        <div className="aboutMeInfo">
          <img src="/avatar.png" alt="avatar" loading="lazy" decoding="async" />
          <div className="intro-content">
            <h2 className="intro-greeting">Hello! I'm Tiffany Ni 👋</h2>
            <p className="intro-main">
              I'm a rising senior undergraduate student at Georgia Tech studying
              computer science. My thread focuses are in{" "}
              <em>Information Internetworks</em> and <em>Intelligence</em>.
            </p>
            <p className="intro-passion">
              In my spare time, I'm always looking for ways to learn as much as
              I can.
            </p>
            <div className="hobbies-section">
              <h3>My Hobbies Include:</h3>
              <ul className="hobbies-list">
                <li>
                  <span className="hobby-icon">🐈</span> Taking care of
                  stray/campus cats
                </li>
                <li>
                  <span className="hobby-icon">🏸</span> Badminton (invite me!)
                </li>
                <li>
                  <span className="hobby-icon">💻</span> Learning on the
                  internet
                </li>
              </ul>
            </div>
            <p className="intro-cta">
              Feel free to explore this portfolio to discover more about me!
            </p>
          </div>
        </div>
      </div>
      <h1 className="subHeading">Fun Facts & Tidbits</h1>
      <div className="morePics">
        <ImageCard
          title={"My Feline Partner in Crime"}
          img="/momoNme.png"
          alt="Momo and I"
          backContent={<p>Back content</p>}
        >
          <p>
            Meet my best friend on campus—Momo! Whether she's offering moral
            support during late-night coding sessions or just being her adorable
            self, Momo is the purr-fect study buddy.
          </p>
        </ImageCard>
        <ImageCard
          title={"Brooklyn Cat and I"}
          img="/catNme.png"
          alt="Momo and I"
        >
          <p>
            Here's a snapshot of me and a stranger cat soaking up the vibes in
            our hometown, Brooklyn. What a brave little cat!
          </p>
        </ImageCard>
        <ImageCard
          title={"Proud Hamster Owner"}
          img="/peanut.JPG"
          alt="hamster cage"
        >
          <p>
            Meet Peanut, my laid-back Roborovski hamster, taking a well-deserved
            break in her sandy paradise. Peanut shows that even the busiest
            little creatures know how to enjoy some downtime.
          </p>
        </ImageCard>
      </div>
    </>
  );
}
